var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLoginBg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 372.61",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{isolation:isolate;}.cls-2{fill:#e6e6e6;}.cls-3{fill:#e0e0e0;}.cls-15,.cls-4{fill:#fafafa;}.cls-22,.cls-5{fill:#f5f5f5;}.cls-6{fill:#f0f0f0;}.cls-18,.cls-21,.cls-23,.cls-7{fill:#fff;}.cls-8{fill:#e58a7b;}.cls-16,.cls-17,.cls-9{fill:#407bff;}.cls-10{opacity:0.2;}.cls-11{fill:#e8ecf1;}.cls-11,.cls-22{mix-blend-mode:multiply;}.cls-12{fill:#263238;}.cls-13{fill:#cf6f64;}.cls-14{fill:#df5753;}.cls-15{opacity:0.56;}.cls-16{opacity:0.07;}.cls-17{opacity:0.47;}.cls-18{opacity:0.1;}.cls-19{opacity:0.6;}.cls-20,.cls-21{opacity:0.4;}.cls-23{opacity:0.3;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Asset 1") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Background_complete",
    "data-name": "Background complete"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    y: 327.45,
    width: 500,
    height: 0.25
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 91.7,
    y: 342.58,
    width: 33.12,
    height: 0.25
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 62.03,
    y: 342.58,
    width: 19.19,
    height: 0.25
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 191.36,
    y: 346.26,
    width: 19.19,
    height: 0.25
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 267.42,
    y: 351.84,
    width: 43.19,
    height: 0.25
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 252.19,
    y: 351.84,
    width: 6.33,
    height: 0.25
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 359.67,
    y: 346.26,
    width: 93.68,
    height: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M237,282.85H43.91a5.71,5.71,0,0,1-5.7-5.71V5.71A5.71,5.71,0,0,1,43.91,0H237a5.71,5.71,0,0,1,5.71,5.71V277.14A5.71,5.71,0,0,1,237,282.85ZM43.91.25a5.46,5.46,0,0,0-5.45,5.46V277.14a5.46,5.46,0,0,0,5.45,5.46H237a5.47,5.47,0,0,0,5.46-5.46V5.71A5.47,5.47,0,0,0,237,.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M453.31,282.85H260.21a5.72,5.72,0,0,1-5.71-5.71V5.71A5.72,5.72,0,0,1,260.21,0h193.1A5.71,5.71,0,0,1,459,5.71V277.14A5.71,5.71,0,0,1,453.31,282.85ZM260.21.25a5.47,5.47,0,0,0-5.46,5.46V277.14a5.47,5.47,0,0,0,5.46,5.46h193.1a5.47,5.47,0,0,0,5.46-5.46V5.71A5.47,5.47,0,0,0,453.31.25Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 245.41,
    y: 242.02,
    width: 21.99,
    height: 87.23
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "263.22 329.26 267.4 329.26 267.4 317.38 258.84 317.38 263.22 329.26"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 149.05,
    y: 242.02,
    width: 21.99,
    height: 87.23
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 167.4,
    y: 242.02,
    width: 100,
    height: 79.94
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M263.77,246v21.16H171V246h92.74m.39-.38H170.64v21.92h93.52V245.57Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "171.57 329.26 167.4 329.26 167.4 317.38 175.95 317.38 171.57 329.26"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M215.19,256.53a2.21,2.21,0,1,0,2.21-2.21A2.21,2.21,0,0,0,215.19,256.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M263.77,271.42v21.15H171V271.42h92.74m.39-.38H170.64V293h93.52V271Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M215.19,282a2.21,2.21,0,1,0,2.21-2.21A2.21,2.21,0,0,0,215.19,282Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M263.77,296.89V318H171V296.89h92.74m.39-.39H170.64v21.93h93.52V296.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M215.19,307.46a2.21,2.21,0,1,0,2.21-2.21A2.21,2.21,0,0,0,215.19,307.46Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 135.62,
    y: 191.36,
    width: 21.99,
    height: 137.9
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "153.43 329.26 157.61 329.26 157.61 317.38 149.06 317.38 153.43 329.26"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 53.44,
    y: 191.36,
    width: 21.99,
    height: 137.9
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 71.78,
    y: 191.36,
    width: 85.83,
    height: 130.61
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M153.91,195.06v29.57H75.48V195.06h78.43m.46-.45H75v30.48h79.35V194.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M153.91,228.23v78.43H116.55V228.23h37.36m.46-.46H116.1v79.35h38.27V227.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M112.84,228.23v78.43H75.48V228.23h37.36m.45-.46H75v79.35h38.27V227.77Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "75.96 329.26 71.78 329.26 71.78 317.38 80.34 317.38 75.96 329.26"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M112.48,209.85a2.22,2.22,0,1,0,2.22-2.21A2.22,2.22,0,0,0,112.48,209.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M120.4,265.57a2.22,2.22,0,1,0,2.21-2.21A2.21,2.21,0,0,0,120.4,265.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M104.57,265.57a2.21,2.21,0,1,0,2.21-2.21A2.21,2.21,0,0,0,104.57,265.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M102.07,152.92H92.8a97.94,97.94,0,0,1,1.61,13.62c0,5-7.06,24.82,3,24.82s3-19.78,3-24.82A97.94,97.94,0,0,1,102.07,152.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M66.8,173.2v6a12.18,12.18,0,0,0,12.14,12.14h6a12.17,12.17,0,0,0,12.14-12.14v-6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M195.67,229.31c0,7,7.83,12.71,17.4,12.71h8.64c9.57,0,17.4-5.72,17.4-12.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M424.61,219.08c-5.24,4.27-12.48,12.11-19.1,23.12-4.42,7.34-7.08,15-8.25,25.19,0-11.5.07-23.85.11-35.51,1.33-3,4.37-9.92,6.55-15.38,7.27-18.24,10-22.72,16.53-38.44,8.73-21,17.67-45.86,15.11-43.88-5.22,4.06-25.22,41.51-27.38,46.87a150,150,0,0,0-10.79,44.85c0-11,.08-21,.12-28.77.14-25.3.57-33.47.78-36,.81-1.28,1.76-2.77,2.32-3.58,4.7-6.79,6.51-12.58,10.93-22.71,6.28-14.36,11.68-39.85,10.1-38.56-6.58,5.35-11.76,16.86-18.58,31.53s-4.87,23.09-6.22,35.62c-.28,2.46-.5,11.73-.66,24.59-1.76-13.7-5.08-22.72-11.13-30.92-7.44-10.09-14.64-16.91-19.92-20.46s9.12,21.22,16,32c6.13,9.63,11.78,18.13,15,26.5-.17,17.42-.25,39.48-.25,60-1.58-9.35-4.16-19.41-7.6-27.2-4.14-9.36-10.5-23.72-15.57-28.6-1.21-1.17,5.3,26.76,9.48,34.19s7.25,14.43,9.88,18.64c.61,1,2.65,4.77,3.81,7,0,25.07.14,47.19.36,54.72h1.08c-.07-1.95-.09-14.7-.06-31.58,2.61-9.16,8.57-19.62,13.49-29.16C416.11,242.74,429.85,214.8,424.61,219.08Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "412.44 329.26 381.1 329.26 378.73 298.54 414.81 298.54 412.44 329.26"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "417.14 302.12 376.39 302.12 375.23 291.75 418.31 291.75 417.14 302.12"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 68.21,
    y: 20.54,
    width: 56.05,
    height: 61.55
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 72.43,
    y: 20.54,
    width: 57.9,
    height: 61.55
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 75.46,
    y: 27.22,
    width: 51.85,
    height: 48.2,
    transform: "translate(152.7 -50.06) rotate(90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 88.02,
    y: 38.9,
    width: 26.71,
    height: 24.83,
    transform: "translate(152.7 -50.06) rotate(90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 357.98,
    y: 27.72,
    width: 52.07,
    height: 57.18
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 361.91,
    y: 27.72,
    width: 53.78,
    height: 57.18
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 364.72,
    y: 33.92,
    width: 48.16,
    height: 44.77,
    transform: "translate(445.11 -332.49) rotate(90)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-5",
    cx: 388.8,
    cy: 56.31,
    r: 13.97
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 140.91,
    y: 57.24,
    width: 41.58,
    height: 45.66
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 144.04,
    y: 57.24,
    width: 42.95,
    height: 45.66
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 146.29,
    y: 62.2,
    width: 38.46,
    height: 35.75,
    transform: "translate(245.59 -85.45) rotate(90)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "165.52 70.35 155.74 87.29 175.3 87.29 165.52 70.35"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Shadow"
  }, /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-5",
    cx: 250,
    cy: 361.29,
    rx: 193.89,
    ry: 11.32
  })), /*#__PURE__*/React.createElement("g", {
    id: "Character_2",
    "data-name": "Character 2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M349.25,108.48l-9.92-4s-13.09,23.87-16.84,25.07c-5.1,1.64-15.66,6.2-21.92,7.06-.85,1-2.24,4.1-2.11,5.24,8.41,2.8,26.89-.92,30.85-3.86C338.32,131.27,349.25,108.48,349.25,108.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M352.3,103.06c1.85,6.84-8.17,20.58-8.17,20.58L331,116.26s2.46-5.65,5.46-11.4C341.27,95.57,350.19,95.26,352.3,103.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M352.3,103.06c1.85,6.84-8.17,20.58-8.17,20.58L331,116.26s2.46-5.65,5.46-11.4C341.27,95.57,350.19,95.26,352.3,103.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M336.21,119.2l5.17,2.89.91-15.86C339.28,108.54,337.16,115.5,336.21,119.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M343.66,97.91S333.44,120.65,339.4,163h40.27c.64-6.18-1.48-36.34,6.19-65.47a103.38,103.38,0,0,0-13.38-1.7,147.88,147.88,0,0,0-17.11,0A78.93,78.93,0,0,0,343.66,97.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M343.66,97.91S333.44,120.65,339.4,163h40.27c.64-6.18-1.48-36.34,6.19-65.47a103.38,103.38,0,0,0-13.38-1.7,147.88,147.88,0,0,0-17.11,0A78.93,78.93,0,0,0,343.66,97.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M334.32,362.19c-.06,1.07,15.21,1.94,34.1,1.94s34.27-.87,34.33-1.94-15.2-1.95-34.1-1.95S334.39,361.12,334.32,362.19Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 357.82,
    y: 336.01,
    width: 7.68,
    height: 17.09,
    transform: "matrix(0.93, -0.36, 0.36, 0.93, -99.7, 153.08)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "393.05 354.5 385.52 354.5 382.76 337.07 390.29 337.07 393.05 354.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M385,353.63h8.46a.61.61,0,0,1,.61.51l1.09,6.7a1.18,1.18,0,0,1-1.18,1.34c-2.95-.06-4.37-.23-8.09-.23-2.29,0-7,.24-10.18.24s-3.39-3.13-2.08-3.41c5.88-1.27,8.16-3,10.12-4.69A1.93,1.93,0,0,1,385,353.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M360,351l8-2.33a.63.63,0,0,1,.75.31l3,6a1.15,1.15,0,0,1-.75,1.59c-2.91.79-4.86,1.29-8.5,2.35-2.51.73-5.07,1.92-7.55,2.71-1.72.55-5.76.57-7.85.57-3.09,0-3.78-3.26-2.45-3.41,3.35-.38,3.8-.2,5.65-1.13a25.86,25.86,0,0,0,8.08-5.58A3.86,3.86,0,0,1,360,351Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M301.83,136.52,293.55,133l-3.41,9.18a34,34,0,0,0,10.24,0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "287.39 132.81 287.17 138.91 290.14 142.21 293.55 133.03 287.39 132.81"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-13",
    x: 356.33,
    y: 336.29,
    width: 7.68,
    height: 8.81,
    transform: "translate(-98.52 152.55) rotate(-21.11)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "390.29 337.07 382.76 337.07 384.19 346.06 391.72 346.06 390.29 337.07"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M338.12,151.53c.15,1.81.32,3.66.54,5.56l29.94-9.72A21.37,21.37,0,0,0,380.12,139c.12-2.67.27-5.48.5-8.41.1-1.43.22-2.89.35-4.37s.31-3.11.5-4.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M347.9,118.74l-1-.13c.59-5,4.32-8.93,8.25-8.84l0,1C351.71,110.7,348.43,114.26,347.9,118.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M353.23,128h-.17l0-1c3.44.13,6.67-3.46,7.2-7.93l1,.12C360.73,124.05,357.12,128,353.23,128Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M371.92,76.54c-1.41,5.51-3.07,15.6.56,19.28,0,0-2.54,5.59-12.77,5.59-9.35,0-4.34-5.59-4.34-5.59,6.22-1.47,6.33-6,5.51-10.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M367.42,80.21l-6.53,5.3a17.71,17.71,0,0,1,.35,3c1.91,1.9,5.74-2.91,6.13-5.37A8,8,0,0,0,367.42,80.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M349.66,76.48a6.56,6.56,0,0,0,4.25,3.13c2.4.54,3.6-1.67,2.94-3.89-.59-2-2.56-4.69-5-4.23A3.34,3.34,0,0,0,349.66,76.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M353.63,58.85c-3.74,1.71-5.06,16.57-.36,18.77S360.71,55.6,353.63,58.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M373.06,68.26c-.9,7.45-1,11.84-5,15.67a9.62,9.62,0,0,1-16.36-5.1c-1.21-6.7.46-17.77,7.94-20.74A9.63,9.63,0,0,1,373.06,68.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M360.77,62.71c5.54-1.41,9.61-2.38,8.15,2.24-1.93,6.15-4.25,12.11-1.14,12.39,1.9.17,10.3-3.39,9.23-7-.93-3.14,3-4,3.7-5.59,2.59-5.76-4.82-5-3.5-8.5s-6-9.14-10-6.34c-6.51,4.54-17.68,4.48-11.81-3,4.21-5.33-3.3-4.24-3.3-4.24s4.54,2.69-3.1,6.85C340.92,54,348.33,65.9,360.77,62.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M376,76.48a7.69,7.69,0,0,1-4.61,3.13c-2.47.54-3.42-1.67-2.49-3.89.83-2,3.11-4.69,5.47-4.23S377.27,74.52,376,76.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M339.4,163s-6.76,60.49-7.29,83.45c-.54,23.89,22.91,98.4,22.91,98.4l12-5s-14-68.07-12-91.52C357.11,222.7,365.87,163,365.87,163Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M356.2,179.6c-5.39,11.18-1.76,33.28,1.16,46.39,1.11-9.25,2.43-19.29,3.68-28.58C360.92,183.12,359.81,172.1,356.2,179.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M366.49,335.87c.06,0,1.42,3.83,1.42,3.83l-13.84,5.81-2.18-4.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M353.69,163s5.17,57.54,8.59,79.09c3.76,23.61,18.5,102.24,18.5,102.24h13.79s-8.26-76.73-9.82-100.1c-1.7-25.36-5.08-81.23-5.08-81.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M394.78,340.72c.06,0,.46,3.86.46,3.86H380.08L379,340.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M389.5,336.17a.13.13,0,0,1-.13-.11c-.08-.7-7.53-70-8.93-91-1.52-22.79-4.58-73.31-4.61-73.82a.14.14,0,0,1,.12-.14h0a.14.14,0,0,1,.13.13c0,.5,3.09,51,4.61,73.81,1.4,21,8.85,90.26,8.92,91a.12.12,0,0,1-.11.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M361.62,70.34c0,.61-.38,1.1-.78,1.1s-.69-.49-.65-1.1.38-1.1.78-1.1S361.66,69.73,361.62,70.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M354.76,70.34c0,.61-.39,1.1-.78,1.1s-.69-.49-.66-1.1.39-1.1.79-1.1S354.8,69.73,354.76,70.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M356.92,70.64a23.28,23.28,0,0,1-3.2,5.2c1,1,2.87.54,2.87.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M357.1,78.93a.17.17,0,0,1-.17-.18.19.19,0,0,1,.19-.18,5.12,5.12,0,0,0,4-1.88.18.18,0,0,1,.25,0,.17.17,0,0,1,0,.25A5.46,5.46,0,0,1,357.1,78.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M362.84,68.49a.34.34,0,0,1-.31,0A2.81,2.81,0,0,0,360,68.2a.33.33,0,0,1-.46-.17.36.36,0,0,1,.19-.47,3.51,3.51,0,0,1,3.23.3.35.35,0,0,1,.09.49A.33.33,0,0,1,362.84,68.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M352.11,66.5a.39.39,0,0,1-.14-.08.35.35,0,0,1,0-.5,3.7,3.7,0,0,1,3.08-1.24.33.33,0,0,1,.28.4.38.38,0,0,1-.42.3h0a3,3,0,0,0-2.43,1A.38.38,0,0,1,352.11,66.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M389.73,107.36l-10.4-2.76s-10.2,25.1-13.81,26.74c-4.9,2.23-17.31,9.95-22.59,13.67-.29,1.24-.06,4.56.6,5.46,9-1.63,26.23-8.26,29.83-11.63C381.57,131.15,389.73,107.36,389.73,107.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M382.47,354.94a2.19,2.19,0,0,1-1.43-.38,1,1,0,0,1-.31-.94.62.62,0,0,1,.34-.51c.84-.42,3.19,1.07,3.46,1.24a.16.16,0,0,1,.07.18.18.18,0,0,1-.14.14A8.86,8.86,0,0,1,382.47,354.94Zm-1-1.55a.53.53,0,0,0-.23,0,.22.22,0,0,0-.12.21.69.69,0,0,0,.2.65,3.59,3.59,0,0,0,2.66.13A6.76,6.76,0,0,0,381.44,353.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M384.41,354.68l-.08,0c-.75-.42-2.16-2.07-1.95-2.91a.6.6,0,0,1,.59-.47.91.91,0,0,1,.75.23c.83.71.88,2.89.88,3a.16.16,0,0,1-.09.16A.17.17,0,0,1,384.41,354.68Zm-1.34-3.05H383c-.23,0-.26.14-.27.18-.12.5.77,1.75,1.51,2.33a4.19,4.19,0,0,0-.75-2.36A.65.65,0,0,0,383.07,351.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M355.92,353.7a2.87,2.87,0,0,1-1.89,0,1,1,0,0,1-.49-.77.61.61,0,0,1,.21-.53c.8-.71,4.07.06,4.44.15a.16.16,0,0,1,.12.15.17.17,0,0,1-.11.18A13.66,13.66,0,0,1,355.92,353.7Zm-1.63-1.19a.82.82,0,0,0-.31.14.22.22,0,0,0-.08.22.6.6,0,0,0,.32.5c.53.29,1.76.06,3.35-.6A9.84,9.84,0,0,0,354.29,352.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M358.17,352.89h-.08c-1-.18-3-1.33-3.06-2.19,0-.2.09-.48.57-.64a1.24,1.24,0,0,1,1,.06c1.08.53,1.65,2.45,1.68,2.53a.2.2,0,0,1-.05.18A.18.18,0,0,1,358.17,352.89Zm-2.37-2.53-.1,0c-.31.11-.31.24-.31.28,0,.51,1.45,1.46,2.46,1.78a3.79,3.79,0,0,0-1.4-2A.92.92,0,0,0,355.8,350.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M343.78,144.42l-10.43,4.8-1.21,2.94,3.85,2.6s7.2-.79,9.25-5.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M344.22,150.64a14.24,14.24,0,0,0-1.94-5.66l1.65-1.23a16.09,16.09,0,0,1,2.32,6.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M346,145.84a2,2,0,1,1-2.44-.78A1.83,1.83,0,0,1,346,145.84Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "326.3 153.1 327.69 154.5 337.05 150.5 333.35 149.22 326.3 153.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M366.49,335.87c.06,0,1.42,3.83,1.42,3.83l-13.84,5.81-2.18-4.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M394.78,340.72c.06,0,.46,3.86.46,3.86H380.08L379,340.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M392.44,104.49c2.75,8.86-8,21-8,21l-14.85-6.06a153.57,153.57,0,0,1,6.08-15.08C380.23,94.52,389.66,95.54,392.44,104.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M392.44,104.49c2.75,8.86-8,21-8,21l-14.85-6.06a153.57,153.57,0,0,1,6.08-15.08C380.23,94.52,389.66,95.54,392.44,104.49Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Screen"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 238.49,
    y: 15.62,
    width: 6.39,
    height: 1.03
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 319.14,
    y: 64.47,
    width: 17.18,
    height: 1.03,
    transform: "translate(248.06 389.46) rotate(-87.42)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "325.61 20.24 207.61 20.24 196.63 265.96 314.63 265.96 325.61 20.24"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "322.09 23.61 204.09 23.61 193.11 269.33 311.11 269.33 322.09 23.61"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "318.57 26.98 200.57 26.98 189.58 272.7 307.58 272.7 318.57 26.98"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "305.14 134.15 204.42 134.15 203.58 152.96 304.3 152.96 305.14 134.15"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "259.81 120.44 205.03 120.44 204.66 128.85 259.44 128.85 259.81 120.44"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "302.87 184.9 202.15 184.9 201.31 203.7 302.03 203.7 302.87 184.9"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "284.4 229.08 216.67 229.08 215.66 251.62 283.39 251.62 284.4 229.08"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M279.87,255.11H212.14l-.09,0a.16.16,0,0,1,0-.09l1-22.54a.11.11,0,0,1,.12-.11h67.73a.11.11,0,0,1,.08,0s0,.06,0,.09L280,255A.13.13,0,0,1,279.87,255.11Zm-67.61-.23h67.49l1-22.31H213.26Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "247.98 171.18 202.76 171.18 202.39 179.59 247.6 179.59 247.98 171.18"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M283.11,73.43a26.53,26.53,0,0,1-5.57,15A26.9,26.9,0,0,1,256.34,99a24.3,24.3,0,0,1-24.46-25.61,27,27,0,0,1,26.75-25.62A24.29,24.29,0,0,1,283.11,73.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M285.52,53.17a7,7,0,0,1-1.48,4A7.17,7.17,0,0,1,278.4,60,6.48,6.48,0,0,1,273,57.17a6.61,6.61,0,0,1-1.12-4A7.19,7.19,0,0,1,279,46.36,6.47,6.47,0,0,1,285.52,53.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M215.27,143.56a3.19,3.19,0,0,1-3.15,3,2.85,2.85,0,0,1-2.88-3,3.18,3.18,0,0,1,3.15-3A2.87,2.87,0,0,1,215.27,143.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M228.75,143.56a3.18,3.18,0,0,1-3.15,3,2.85,2.85,0,0,1-2.87-3,3.18,3.18,0,0,1,3.14-3A2.85,2.85,0,0,1,228.75,143.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M242.24,143.56a3.18,3.18,0,0,1-3.15,3,2.86,2.86,0,0,1-2.88-3,3.19,3.19,0,0,1,3.15-3A2.86,2.86,0,0,1,242.24,143.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M213,194.3a3.19,3.19,0,0,1-3.15,3,2.86,2.86,0,0,1-2.88-3,3.18,3.18,0,0,1,3.15-3A2.86,2.86,0,0,1,213,194.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M226.48,194.3a3.17,3.17,0,0,1-3.14,3,2.85,2.85,0,0,1-2.88-3,3.18,3.18,0,0,1,3.15-3A2.85,2.85,0,0,1,226.48,194.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M240,194.3a3.18,3.18,0,0,1-3.15,3,2.86,2.86,0,0,1-2.88-3,3.19,3.19,0,0,1,3.15-3A2.85,2.85,0,0,1,240,194.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M253.46,194.3a3.19,3.19,0,0,1-3.15,3,2.86,2.86,0,0,1-2.88-3,3.19,3.19,0,0,1,3.15-3A2.86,2.86,0,0,1,253.46,194.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M267,194.3a3.19,3.19,0,0,1-3.15,3,2.85,2.85,0,0,1-2.88-3,3.18,3.18,0,0,1,3.15-3A2.86,2.86,0,0,1,267,194.3Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-9",
    cx: 257.87,
    cy: 64.86,
    rx: 10.6,
    ry: 10.13,
    transform: "translate(28.14 198.77) rotate(-44.36)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M277.54,88.48A26.9,26.9,0,0,1,256.34,99,24.29,24.29,0,0,1,236.1,88.48c4.86-4.84,12.55-8,21.07-8S273.11,83.64,277.54,88.48Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-18",
    cx: 257.87,
    cy: 64.86,
    rx: 10.6,
    ry: 10.13,
    transform: "translate(28.14 198.77) rotate(-44.36)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M277.54,88.48A26.9,26.9,0,0,1,256.34,99,24.29,24.29,0,0,1,236.1,88.48c4.86-4.84,12.55-8,21.07-8S273.11,83.64,277.54,88.48Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Character_1",
    "data-name": "Character 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M130.41,157.49c-.95,2.08-1.95,4.36-2.82,6.59s-1.76,4.5-2.53,6.79a86,86,0,0,0-3.58,13.8l-.22,1.47a2.15,2.15,0,0,0,.07.75,7.65,7.65,0,0,0,1.1,2.31,29,29,0,0,0,4.44,5,67.35,67.35,0,0,0,5.52,4.61c1.92,1.48,3.94,2.92,5.93,4.28l-1.87,3.5A70.28,70.28,0,0,1,123,198.9a32.39,32.39,0,0,1-6-5.68,14.38,14.38,0,0,1-2.39-4.27,9.75,9.75,0,0,1-.48-2.95c0-.25,0-.59,0-.76l0-.5.1-1a78.06,78.06,0,0,1,3.27-15.34c.78-2.47,1.61-4.91,2.56-7.31s1.93-4.73,3.14-7.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M136.91,202.48l7.07-3.59-1.83,7.77s-4.85,1.36-7.1-1Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "150.45 200.17 148.57 206.59 142.15 206.66 143.98 198.9 150.45 200.17"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M160.43,120.05a20.21,20.21,0,0,0,1.59,4,1.63,1.63,0,0,1-1.59.51Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-12",
    cx: 160.22,
    cy: 118.96,
    rx: 0.75,
    ry: 1.15
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M160,117.85l1.52-.44S160.78,118.6,160,117.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M140.9,127.38c.91,4.66,1.82,13.19-1.44,16.29,0,0,1.28,4.73,9.93,4.73,9.51,0,4.54-4.72,4.54-4.72-5.19-1.24-5.06-5.1-4.15-8.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M138.37,116.79c.48,7.77.52,11.07,4.44,15.06,5.91,6,15.35,3.71,17.2-4,1.67-7,.61-18.52-7-21.62A10.63,10.63,0,0,0,138.37,116.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M139.14,108c-3.9,1.42-9.1.36-7.06,12.39,2.16,12.73-1.16,16.92-1.16,16.92s14.79,3.16,29.89-.18c0,0-4.61-8.07-3.32-13.95,1.65-7.5.35-10.27.35-10.27S144.62,106,139.14,108Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M155.64,120.84a7.81,7.81,0,0,0,1.22,4.17c1.06,1.62,2.31,1,2.62-.72.28-1.52.07-4.19-1.28-5.22S155.66,119.08,155.64,120.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M135.75,109.36c-1.12-3.15,4.22-8,15.52-6s11.79,11.4,11.79,11.4l-2.28-2.71.1,2.86-11.61,2.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M136.71,144.2h0a1.76,1.76,0,0,1,1.45-2c3.52-.58,11.52-1.76,15.54-1.2,3,.41,3.78,2.16,3.91,3.59a1.76,1.76,0,0,1-1.85,1.9l-17.38-.78A1.78,1.78,0,0,1,136.71,144.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M136.71,144.2h0a1.76,1.76,0,0,1,1.45-2c3.52-.58,11.52-1.76,15.54-1.2,3,.41,3.78,2.16,3.91,3.59a1.76,1.76,0,0,1-1.85,1.9l-17.38-.78A1.78,1.78,0,0,1,136.71,144.2Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "146.76 318.91 153.21 323.38 164 308.76 157.55 304.28 146.76 318.91"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "131.72 318.61 138.53 322.5 148.08 307.03 141.27 303.14 131.72 318.61"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "163.99 308.76 158.43 316.3 151.98 311.82 157.54 304.29 163.99 308.76"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "141.26 303.15 148.08 307.03 143.16 315 136.34 311.12 141.26 303.15"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M152.2,193s25.18,31.73,20.45,62.08c-3.81,24.51-25.91,57.7-25.91,57.7l-10.39-5.16a339.26,339.26,0,0,0,18.7-45.44,33.59,33.59,0,0,0-4-29.1c-12.76-18.63-33.2-7.55-19.45-40.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M152.2,193s25.18,31.73,20.45,62.08c-3.81,24.51-25.91,57.7-25.91,57.7l-10.39-5.16a339.26,339.26,0,0,0,18.7-45.44,33.59,33.59,0,0,0-4-29.1c-12.76-18.63-33.2-7.55-19.45-40.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M164.55,213.43l-3.66-3.64c0,.29,7.09,44.05,9.08,56.35a74.71,74.71,0,0,0,2.69-11C175,240.26,170.11,225.06,164.55,213.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M163.44,193s30.32,39.88,31.18,63.79c.71,20-33,58.75-33,58.75l-9.8-6.34s19.73-27.52,24.7-50C174.6,237,134,193,134,193Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M163.44,193s30.32,39.88,31.18,63.79c.71,20-33,58.75-33,58.75l-9.8-6.34s19.73-27.52,24.7-50C174.6,237,134,193,134,193Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M125.93,145.46c-3.24.76-6.35,12.55-6.35,12.55l12.67,8.45s4.22-9.31,2.74-13.39C133.46,148.82,130,144.49,125.93,145.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M128.41,153l-.88,10.27,4.71,3.16a42.42,42.42,0,0,0,2.87-9.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M167.19,145.68s3.74,1.32-3.75,47.36H131.58c.54-13,.55-21-5.65-47.58a95.14,95.14,0,0,1,13.53-1.79,102.58,102.58,0,0,1,14.47,0C160.15,144.24,167.19,145.68,167.19,145.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M170.43,153c.72,2,1.48,4.16,2.28,6.23s1.56,4.2,2.37,6.29l2.45,6.28.62,1.57.32.79.15.39c0,.07,0,.07,0,.06a2.13,2.13,0,0,0-.7-.63,2.73,2.73,0,0,0-1.3-.38,2.64,2.64,0,0,0-1.11.2c-.46.22-.46.31-.45.3a1.68,1.68,0,0,0,.22-.23,14,14,0,0,0,1.43-2.33c.47-.92.92-1.9,1.37-2.89.88-2,1.69-4.07,2.5-6.16s1.58-4.21,2.33-6.33l2.28-6.39,3.85,1c-.76,4.56-1.74,9-2.92,13.52-.57,2.25-1.24,4.48-2,6.73-.38,1.12-.8,2.25-1.28,3.39A21.23,21.23,0,0,1,181,178a9.32,9.32,0,0,1-.88,1.08,5.56,5.56,0,0,1-1.82,1.29,4.48,4.48,0,0,1-1.94.36,4.41,4.41,0,0,1-2.11-.64,5.29,5.29,0,0,1-1.82-1.88c-.15-.26-.28-.52-.37-.71l-.19-.39-.38-.77-.76-1.56c-1-2.08-2-4.17-2.87-6.28s-1.79-4.26-2.65-6.4-1.63-4.3-2.36-6.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M167.19,145.68c3.83.92,8.14,12.23,8.14,12.23l-11.39,9.7s-7.37-12.34-5.88-16.41C159.61,147,162.19,144.49,167.19,145.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M187,146.24l4-3.34,2.78,4.32-2.05,3.62s-3.26,3-6.14,1.47h0A5.17,5.17,0,0,1,187,146.24Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "198.22 142.91 197.92 143.99 191.59 145.06 190.97 142.9 198.22 142.91"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "162.4 316.1 150.98 308.71 153.03 305.16 165.86 313.05 162.4 316.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M143,322a6.74,6.74,0,0,1-2.82-1,.17.17,0,0,1-.1-.18.21.21,0,0,1,.13-.16c.31-.09,3-.92,3.78-.28a.62.62,0,0,1,.22.6,1.07,1.07,0,0,1-.57.87A1.44,1.44,0,0,1,143,322Zm-2.25-1.09c1.25.63,2.25.87,2.73.63a.7.7,0,0,0,.36-.59.24.24,0,0,0-.09-.26C143.33,320.32,141.83,320.58,140.73,320.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M140.25,321a.2.2,0,0,1-.14-.06.19.19,0,0,1,0-.18c0-.09.65-2.26,1.67-2.76a1,1,0,0,1,.83,0,.66.66,0,0,1,.46.67c-.07.9-1.9,2.14-2.74,2.34Zm1.94-2.73a.55.55,0,0,0-.28.07c-.62.29-1.13,1.47-1.38,2.18.88-.37,2.09-1.35,2.13-1.9,0-.09,0-.21-.23-.3A.74.74,0,0,0,142.19,318.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M157.27,326.29c-1.13,0-2.7-1.44-3.56-2.33a.18.18,0,0,1,0-.21.22.22,0,0,1,.19-.11c.4.06,3.87.52,4.36,1.51a.57.57,0,0,1,0,.58,1,1,0,0,1-.79.56Zm-2.9-2.2c1.26,1.23,2.37,1.91,3,1.83a.68.68,0,0,0,.52-.37.23.23,0,0,0,0-.24C157.63,324.78,155.78,324.32,154.37,324.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M154.48,324.06a3.27,3.27,0,0,1-.67-.05.19.19,0,0,1-.14-.12.19.19,0,0,1,0-.18c.06-.07,1.41-1.7,2.69-1.81a1.35,1.35,0,0,1,1,.32c.39.34.37.64.27.83C157.38,323.72,155.65,324.06,154.48,324.06Zm-.26-.37c1.12.06,2.91-.31,3.14-.8,0,0,.08-.16-.18-.39a1,1,0,0,0-.76-.23A4.25,4.25,0,0,0,154.22,323.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M140.52,320l-8.48-2.4a.62.62,0,0,0-.75.34l-2.86,6.44a1.26,1.26,0,0,0,.83,1.69c3,.78,4.44,1,8.17,2.06,2.3.65,5.58,1.84,8.75,2.73s4.23-2.19,3-2.84c-5.56-2.95-6-5-7.52-7.2A2,2,0,0,0,140.52,320Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M153.94,322.79l-7.24-5a.63.63,0,0,0-.82.09l-4.8,5.15a1.26,1.26,0,0,0,.24,1.87c2.55,1.7,3.87,2.4,7.06,4.61,2,1.36,5.87,4.38,8.57,6.26s4.71-.7,3.75-1.72c-4.3-4.6-5.24-7.48-5.95-10.09A2.05,2.05,0,0,0,153.94,322.79Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "148.07 313.48 135.02 306.99 136.37 303.46 150.31 310.29 148.07 313.48"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M131.1,191.17,130,194c-.11.22.15.44.52.44H163.6c.29,0,.53-.14.55-.32l.28-2.85c0-.2-.23-.36-.54-.36H131.62A.58.58,0,0,0,131.1,191.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M131.1,191.17,130,194c-.11.22.15.44.52.44H163.6c.29,0,.53-.14.55-.32l.28-2.85c0-.2-.23-.36-.54-.36H131.62A.58.58,0,0,0,131.1,191.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M136.31,194.77h-.87c-.17,0-.3-.08-.29-.19l.41-3.71c0-.11.16-.2.33-.2h.87c.17,0,.3.09.29.2l-.41,3.71C136.63,194.69,136.48,194.77,136.31,194.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M156.71,194.77h-.86c-.17,0-.3-.08-.29-.19l.4-3.71c0-.11.17-.2.34-.2h.86c.17,0,.31.09.29.2l-.4,3.71C157,194.69,156.89,194.77,156.71,194.77Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-22",
    cx: 135.55,
    cy: 362.19,
    rx: 26.79,
    ry: 1.94
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M151.87,359.45c-4.74-1.38-10-3.15-13.18-5l-.28-.13V332.85H148a2.86,2.86,0,0,0,0-5.71h-9.54V229.31H132.7v97.83h-9.53a2.86,2.86,0,1,0,0,5.71h9.53v21.43l-.27.13c-3.23,1.89-8.45,3.66-13.19,5a1.4,1.4,0,0,0,.39,2.74h31.85A1.4,1.4,0,0,0,151.87,359.45Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 112.6,
    y: 219.36,
    width: 45.92,
    height: 20.93,
    rx: 5.18
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M117.45,240.29v1.82c0,1.5,1.63,2.73,3.63,2.73h29c2,0,3.63-1.23,3.63-2.73v-1.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M117.45,240.29v1.82c0,1.5,1.63,2.73,3.63,2.73h29c2,0,3.63-1.23,3.63-2.73v-1.82Z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoginBg);
export default __webpack_public_path__ + "static/media/login-bg.f4604af4990a5ec91c02ff05fce046f0.svg";
export { ForwardRef as ReactComponent };